import React from 'react'
import { ucFirst } from '../../../helpers/string_helper'
import { ActivityModule, Modules } from '../../../constants/Module'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { withTranslation } from 'react-i18next'
function ApprovalUser({ item, t }) {
    return (
        <>
            <div className="mx-2">
                <div>
                    <strong>{ucFirst(Modules.APPROVAL_USER)} ({item?.payload?.user?.name} | {item?.payload?.user?.uniqueUserId}) </strong>
                    {t('was added for')} <strong>{item?.payload?.module === Modules.PROJECT_DELIVERABLE ? 'deliverable' : item?.payload?.module} {item?.payload?.module !== Modules.PROJECT_DELIVERABLE ? (
                        <>
                            {item?.payload?.moduleDetails?.name}
                            {item?.payload?.module === ActivityModule.PROJECT ? ` | ${item?.payload?.moduleDetails?.uniqueProjectId}` : ''}
                        </>
                    ) : ''}</strong> {item?.payload?.module === Modules.PROJECT_DELIVERABLE && (
                        <>
                            under startup <strong>{item.project.name} ({item.project.uniqueProjectId})</strong>
                        </>
                    )}
                    <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                </div>
                <div>
                    <div className="mx-2">
                        <div className="d-flex align-items-center change_status">
                            <span>{t('Approval is pending from')} <strong>{item?.payload?.userRole?.name} [{item?.payload?.user?.name} | {item?.payload?.user?.uniqueUserId}]</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div></>
    )
}
export default withTranslation()(ApprovalUser)